import axios from 'axios';
import Swal from 'sweetalert2';

const baseURL = process.env.REACT_APP_API_URL;

export const axiosClient = axios.create({
	baseURL: baseURL,
	headers: {
		'Content-type': 'application/json',
	},
});

export async function getToken() {
	const token = localStorage.getItem('pxc-tkn') || '';
	axiosClient.defaults.headers.common['Authorization'] = token;
	return token;
}

// Attach Authorization header automatically
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('pxc-tkn') || '';
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = token;
  }
  return config;
});

function isPublicPath(pathname: string): boolean {
  const pubPrefixes = [
    '/login',
    '/signup',
    '/resetPassword',
    '/recuperacion',
    '/payment/success',
    '/payment/cancel',
    '/comprobante/pdf/',
    '/comprobante/descarga/',
    '/comprobante/xml/',
  ];
  return pubPrefixes.some((p) => pathname.startsWith(p));
}

function forceLogoutAndRedirect(message?: string) {
  try {
    // Best-effort notify user
    if (message) {
      Swal.fire({
        position: 'top-end',
        icon: 'warning',
        title: message,
        showConfirmButton: false,
        timer: 2500,
      });
    }
  } catch (_) {
    // ignore swal errors
  }

  // Clear local session keys used by the app
  localStorage.setItem('pxc-tkn', '');
  localStorage.setItem('pxc-tkn-init-date', '');
  localStorage.setItem('pxcUser', '');
  localStorage.setItem('pxcCntAct', '');
  localStorage.setItem('pxc-expired-notified', '1');

  // Redirect to login (ensures route guard triggers), avoid loops if already there
  if (typeof window !== 'undefined') {
    const path = window.location?.pathname || '';
    // Avoid loops and do not hijack public routes
    if (!isPublicPath(path)) {
      window.location.replace('/login/');
    }
  }
}

// Normalize auth errors: redirect on 401 or invalid/expired token
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const data = error?.response?.data;

    // Recognize API invalid-token variants
    const dataStr = typeof data === 'string' ? data : data?.message || '';
    const isInvalidTokenMsg =
      typeof dataStr === 'string' &&
      (
        dataStr.toLowerCase().includes('invalid token') ||
        dataStr.toLowerCase().includes('requiere autenticación') ||
        dataStr.toLowerCase().includes('access denied') ||
        (dataStr.toLowerCase().includes('token') && dataStr.toLowerCase().includes('expir'))
      );

    if (status === 401 || (status === 400 && isInvalidTokenMsg)) {
      forceLogoutAndRedirect('Tu sesión expiró. Inicia sesión nuevamente.');
    }

    return Promise.reject(error);
  }
);
